import React from 'react';
// import { setActiveUser, setUserLogoutState } from '../../features/userSlice.js';
// import { useDispatch } from 'react-redux';
// import { auth } from '../../firebase';
// import { DualRing } from 'react-awesome-spinners';
// import { useNavigate } from 'react-router-dom';
import AboutContact from '../../components/AboutContact/AboutContact';
import AboutSection from '../../components/AboutSection/AboutSection';
import AboutStepsSection from '../../components/AboutStepsSection/AboutStepsSection';
import Footer from '../../components/Footer/Footer';
import SliderImage from '../../components/SliderImage/SliderImage';
import { motion } from 'framer-motion';

function About() {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const getData = () => {
  //     auth.onAuthStateChanged((authUser) => {
  //       if (authUser) {
  //         setLoading(true);
  //         dispatch(
  //           setActiveUser({
  //             userName: authUser.displayName,
  //             userEmail: authUser.email,
  //           })
  //         );
  //         setLoading(false);
  //       } else {
  //         setLoading(true);
  //         dispatch(setUserLogoutState());
  //         navigate('/login');
  //         setLoading(false);
  //       }
  //     });
  //   };
  //   getData();
  // }, [dispatch, loading, navigate]);

  //   <div className='flex justify-center items-center h-screen w-full'>
  //   <DualRing size={100} color='#22c55e' />
  // </div>

  return (
    <motion.div
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: '100vw', opacity: 1 }}
      exit={{
        width: window.innerWidth,
        opacity: 0,
        transition: { duration: 0.1 },
      }}
    >
      <SliderImage />

      <AboutSection />

      <AboutStepsSection />

      <AboutContact />

      <Footer />
    </motion.div>
  );
}

export default About;
